<template>
  <div>
    <van-popup v-model="show" class="popup__advert" closeable @close="close">
      <!-- 广告弹窗 -->
      <div v-if="imageUrl" class="zjs__advert">
        <a
          v-trackevent="{
            type: 'funcTracker',
            action: 'click',
            opt_label: '页码页维护弹框_click',
            opt_value: link
          }"
          :href="link"
          :class="{ outerAd: needAdPrint }"
        >
          <img :src="imageUrl" />
        </a>
        <div class="zjs-advert-close" @click.stop>
          <div @click.stop="close">
            <img src="./img/close.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
export default {

  data() {
    return {
      show: false,
      imageUrl: 'https://img.yzcdn.cn/upload_files/2020/07/02/FhX4HFsQD8lnKlO-S_NN-5rRao_3.png',
      link: '/cms/static/angular/workbookHoliday/wb_holiday_subscription.html',
      needAdPrint: null
    }
  },
  mounted() {
    register({
      name: 'SummerAssignmentSubscription',
      open: ({ afterClose }) => {
        this.afterClose = afterClose
        this.show = true
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    }
  }
}
</script>

<style lang="scss">
.popup__advert.van-popup {
  background-color: transparent;
  width: 70%;
}
.popup__advert .van-popup__close-icon--top-right {
  display: none;
  position: absolute;
  top: 2.96rem;
  right: 0.44rem;
  font-size: 0.4rem;
}
</style>
<style lang="scss" scoped>
.zjs__advert {
  position: relative;
  width: 100%;

  a {
    display: block;

    img {
      display: block;
      width: 100%;
    }
  }

  .zjs-advert-close {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 20px;

    div {
      width: 10%;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .outerAd {
    position: relative;
  }
}
</style>
